"use client"

import { BiError } from "react-icons/bi"

export default function ErrorAlert({ error, onDismiss }) {
  if (!error) return null

  return (
    <div className="alert alert-danger alert-dismissible d-flex align-items-center py-2 rounded-0" role="alert">
      <BiError className="me-1 fs-5" />
      <div className="flex-grow-1">
        <strong>Erreur !</strong> {error}
      </div>
      {onDismiss && <button type="button" className="btn-close btn-sm py-2 px-3" onClick={onDismiss} aria-label="Close"></button>}
    </div>
  )
}